/* eslint-disable @typescript-eslint/no-namespace */
export namespace App.Http.Controllers.AIAssistant {
  export interface CreateAIAssistantData {
    external_id: string
    language: string
    type: string
    description: string | null
  }
  export interface DeleteAIAssistantData {
    id: any
  }
  export interface UpdateAIAssistantData {
    id: any
    external_id: string
    language: string
    type: string
    description: string | null
  }
}
export namespace App.Http.Controllers.AIConnector {
  export interface CreateAIConnectorData {
    label: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    service: Modules.AIConnector.Enums.ServiceEnum
    region: string | null
    endpoint: string | null
    secret: string | null
    config: Array<any> | null
    maxConcurrency: number | null
    timeoutSec: number | null
    sortOrder: number | null
    status: Modules.AIConnector.Enums.StatusEnum
    notes: string | null
    isDefault: boolean
  }
  export interface DeleteAIConnectorData {
    id: any
  }
  export interface UpdateAIConnectorData {
    id: any
    label: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    service: Modules.AIConnector.Enums.ServiceEnum
    region: string | null
    endpoint: string | null
    secret: string | null
    config: Array<any> | null
    maxConcurrency: number | null
    timeoutSec: number | null
    sortOrder: number | null
    status: Modules.AIConnector.Enums.StatusEnum
    notes: string | null
    isDefault: boolean
  }
}
export namespace App.Http.Controllers.AIProfile {
  export interface AIProfileAppearanceOptionsQueryData {
    profileId: any | null
    isShared: boolean
  }
  export interface CopyAIProfileData {
    id: any
    organizationId: any | null
  }
  export interface CreateAIProfileData {
    name: string
    settings: string | null
    aiAssistantId: any | null
    isShared: boolean
    loopAvatarId: any | null
    realtimeAvatarId: any | null
    mascot: Modules.AIProfile.Enums.MascotEnum | null
    ttsVoiceId: any | null
  }
  export interface DeleteAIProfileData {
    id: any
  }
  export interface UpdateAIProfileData {
    id: any
    name: string
    settings: string | null
    aiAssistantId: any | null
    isShared: boolean
    loopAvatarId: any | any | null
    realtimeAvatarId: any | any | null
    mascot: Modules.AIProfile.Enums.MascotEnum | any | null
    ttsVoiceId: any | any | null
  }
}
export namespace App.Http.Controllers.AIPrompt {
  export interface CreateAIPromptData {
    name: string
    content: string
    description: string | null
    model: string | null
    temperature: number | null
    topP: number | null
    responseFormat: Array<any> | null
    tools: Array<any> | null
    reasoningEffort: Modules.LLM.Enums.ReasoningEffortEnum | null
  }
  export interface DeleteAIPromptData {
    id: any
  }
  export interface RollbackAIPromptData {
    versionId: any
  }
  export interface UpdateAIPromptData {
    id: any
    name: string
    content: string
    description: string | null
    model: string | null
    temperature: number | null
    topP: number | null
    responseFormat: Array<any> | null
    tools: Array<any> | null
    reasoningEffort: any | Modules.LLM.Enums.ReasoningEffortEnum | null
  }
}
export namespace App.Http.Controllers.Account {
  export interface AccountData {
    name: string
    last_name: string
    patronymic: string | null
    email: string
    phone: string | null
    timezone: string
    avatar: boolean
  }
  export interface LanguageData {
    language: string
  }
}
export namespace App.Http.Controllers.Account.Avatar {
  export interface UploadAvatarData {
    avatar: any
  }
}
export namespace App.Http.Controllers.Analytics {
  export interface BatchReportRequestData {
    competenceId: string
    periodStart: string
    periodEnd: string
    userIds: { [key: number]: string }
  }
  export interface DepartmentAggregationRequestData {
    competenceId: string | null
    startDate: string | null
    endDate: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface EmployeeComparisonRequestData {
    playerIds: { [key: number]: string }
    competenceId: string
    startDate: string | null
    endDate: string | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface EngagementRequestData {
    startDate: string | null
    endDate: string | null
    inactiveDaysThreshold: number
    page: number
    itemsPerPage: number
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface EvaluatorConsistencyRequestData {
    competenceId: string | null
    startDate: string | null
    endDate: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface GamesScoreRequestData {
    startDate: string | null
    endDate: string | null
    competenceId: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface ProgressOverTimeRequestData {
    competenceId: string
    period: string
    startDate: string | null
    endDate: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface ReportArchiveRequestData {
    ids: { [key: number]: string }
  }
  export interface ReportCandidatesRequestData {
    competenceId: string
    periodStart: string
    periodEnd: string
  }
  export interface ScoreDistributionRequestData {
    competenceId: string
    skillId: string | null
    evaluatorType: string | null
    startDate: string | null
    endDate: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface SkillGapHeatmapRequestData {
    competenceId: string
    startDate: string | null
    endDate: string | null
    evaluatorType: string | null
    page: number
    itemsPerPage: number
    search: string | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface TopPlayersRequestData {
    competenceId: string
    startDate: string | null
    endDate: string | null
    evaluatorType: Modules.Evaluation.Enums.EvaluatorTypeEnum | null
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
  }
  export interface ToursRequestData {
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
    page: number
    itemsPerPage: number
    competence_id: any | null
    status: string | null
    scenario_id: any | null
    tour_id: any | null
    search: string | null
    orderBy: string
    sortBy: string
    upcomingGamesOnly: string | null
    expertRequest: string | null
    playerId: string | null
    ids: Array<any> | null
    tourIds: Array<any> | null
    role: string | null
    activity: string | null
  }
}
export namespace App.Http.Controllers.Auth {
  export interface AuthResponse {
    userAbilityRules: Array<any>
    userData: App.Http.Controllers.Auth.UserData
    organizationSettings: Modules.Organization.OrganizationSettingsData
  }
  export interface UserData {
    id: string
    fullName: string
    username: string
    avatar: boolean
    email: string
    timezone: string
    isEmailVerified: boolean
    roles: Array<any>
  }
}
export namespace App.Http.Controllers.Chat {
  export interface SendMessageData {
    user_id: any
    message: string
  }
}
export namespace App.Http.Controllers.Competencies {
  export interface CopyCompetenceData {
    id: any
    organizationId: any | null
  }
  export interface CreateCompetenceData {
    ai_assistant_type: Modules.Competence.Enums.AIAssistantTypeEnum
    title: string
    text: string | null
    language: string | null
    department_id: any | null
    ai_prompt_id: any | null
    evaluation_format: Modules.Rubric.Enums.EvaluationFormatEnum | null
    rubric_id: any | null
  }
  export interface DeleteCompetenceData {
    id: any
  }
  export interface ReorderCompetenceData {
    currentItemId: any
    newDisplayOrder: number
  }
  export interface UpdateCompetenceData {
    id: any
    ai_assistant_type: Modules.Competence.Enums.AIAssistantTypeEnum
    title: string
    text: string | null
    language: string | null
    department_id: any | null
    ai_prompt_id: any | any | null
    evaluation_format: Modules.Rubric.Enums.EvaluationFormatEnum | any | null
    rubric_id: any | any | null
  }
}
export namespace App.Http.Controllers.Departments {
  export interface CreateDepartmentData {
    title: string
  }
  export interface DeleteDepartmentData {
    id: any
  }
  export interface UpdateDepartmentData {
    id: any
    title: string
  }
}
export namespace App.Http.Controllers.Evaluations {
  export interface DeleteVideoComment {
    id: any
  }
}
export namespace App.Http.Controllers.FAQ {
  export interface CopyFAQData {
    id: any
    organizationId: any | null
  }
  export interface CreateFAQData {
    title: string
    text: string | null
    language: string | null
    managersOnly: boolean
  }
  export interface DeleteFAQData {
    id: any
  }
  export interface UpdateFAQData {
    id: any
    title: string
    text: string | null
    language: string | null
    managersOnly: boolean
  }
}
export namespace App.Http.Controllers.Games {
  export interface DeleteGameData {
    id: any
  }
  export interface MarkGameFailedData {
    id: any
  }
  export interface RestoreGameData {
    id: any
  }
}
export namespace App.Http.Controllers.Library {
  export interface CreateLibraryData {
    id: any | null
    title: string
    isPublic: boolean
    tmpFilePath: string | null
    text: string | null
  }
  export interface DeleteLibraryData {
    id: any
  }
  export interface UploadedVideoData {
    file: any
  }
}
export namespace App.Http.Controllers.LoopAvatar {
  export interface LoopAvatarCatalogItemData {
    id: any
    organizationId: any | null
    name: string
    gender: Modules.LoopAvatar.Enums.LoopAvatarGenderEnum
    emotion: Modules.LoopAvatar.Enums.LoopAvatarEmotionEnum
    version: number
    posterUrl: string
    profilesCount: number
  }
  export interface LoopAvatarDetachPreviewQueryData {
    organizationId: any | null
  }
  export interface SelectableLoopAvatarData {
    id: any
    name: string
    gender: Modules.LoopAvatar.Enums.LoopAvatarGenderEnum
    emotion: Modules.LoopAvatar.Enums.LoopAvatarEmotionEnum
    version: number
    posterUrl: string
    listenUrl: string
  }
  export interface SelectableLoopAvatarsQueryData {
    profileId: any | null
    isShared: boolean
    gender: Modules.LoopAvatar.Enums.LoopAvatarGenderEnum | null
    emotion: Modules.LoopAvatar.Enums.LoopAvatarEmotionEnum | null
  }
  export interface StoreLoopAvatarData {
    package: any
    organizationId: any | null
  }
  export interface UpdateLoopAvatarData {
    name: string
    gender: Modules.LoopAvatar.Enums.LoopAvatarGenderEnum
    emotion: Modules.LoopAvatar.Enums.LoopAvatarEmotionEnum
    organizationId: any | null
  }
  export interface UploadLoopAvatarVersionData {
    package: any
  }
}
export namespace App.Http.Controllers.Notifications {
  export interface EditNotificationData {
    id: any
  }
}
export namespace App.Http.Controllers.Organizations {
  export interface DeleteOrganizationData {
    id: any
  }
}
export namespace App.Http.Controllers.Positions {
  export interface CreatePositionData {
    title: string
  }
  export interface DeletePositionData {
    id: any
  }
  export interface UpdatePositionData {
    id: any
    title: string
  }
}
export namespace App.Http.Controllers.RealtimeAvatar {
  export interface RealtimeAvatarCatalogItemData {
    id: any
    organizationId: any | null
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    mediaVersion: number
    availableModels: { [key: number]: string }
    posterUrl: string
    previewUrl: string | null
    profilesCount: number
  }
  export interface RealtimeAvatarDetachPreviewQueryData {
    organizationId: any | null
  }
  export interface SelectableRealtimeAvatarData {
    id: any
    name: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    posterUrl: string
    previewUrl: string | null
  }
  export interface SelectableRealtimeAvatarsQueryData {
    profileId: any | null
    isShared: boolean
  }
  export interface StoreRealtimeAvatarData {
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    name: string | null
    organizationId: any | null
  }
  export interface UpdateRealtimeAvatarData {
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    organizationId: any | null
  }
}
export namespace App.Http.Controllers.Rubric {
  export interface CreateRubricData {
    name: string
    criteria: Array<any>
  }
  export interface DeleteRubricData {
    id: any
  }
  export interface RollbackRubricData {
    versionId: any
  }
  export interface UpdateRubricData {
    id: any
    name: string
    criteria: Array<any>
  }
}
export namespace App.Http.Controllers.Scenarios {
  export interface CopyScenarioData {
    id: any
    organizationId: any | null
  }
  export interface DeleteScenarioData {
    id: any
  }
}
export namespace App.Http.Controllers.Scenarios.Image {
  export interface UploadImageData {
    image: any
  }
}
export namespace App.Http.Controllers.Skills {
  export interface CreateSkillData {
    competence_id: any
    title: string
    text: string | null
  }
  export interface DeleteSkillData {
    id: any
  }
  export interface ReorderSkillData {
    currentItemId: any
    newDisplayOrder: number
  }
  export interface UpdateSkillData {
    id: any
    competence_id: any
    title: string
    text: string | null
  }
}
export namespace App.Http.Controllers.Statistics {
  export interface ActivityCalendarRequestData {
    playerId: string | null
  }
  export interface EvaluationGapRequestData {
    competenceId: string | null
    playerId: string | null
    startDate: string | null
    endDate: string | null
  }
  export interface GenerateReportRequestData {
    competenceId: string
    periodStart: string
    periodEnd: string
    playerId: string | null
  }
  export interface ImprovementVelocityRequestData {
    competenceId: string | null
    playerId: string | null
  }
  export interface PeerPercentileRequestData {
    competenceId: string | null
    playerId: string | null
  }
  export interface PlayerRadarRequestData {
    competenceId: string
    startDate: string | null
    endDate: string | null
    playerId: string | null
    evaluatorType: Modules.Evaluation.Enums.EvaluatorTypeEnum | null
  }
  export interface PlayerSkillTrendRequestData {
    competenceId: string
    playerId: string | null
  }
  export interface PlayerStrengthsRequestData {
    competenceId: string | null
    startDate: string | null
    endDate: string | null
    playerId: string | null
  }
  export interface RankingRequestData {
    departmentIds: { [key: number]: string } | null
    positionIds: { [key: number]: string } | null
    userIds: { [key: number]: string } | null
    scenarioIds: { [key: number]: string } | null
    page: number
    itemsPerPage: number
    competence_id: any | null
    status: string | null
    scenario_id: any | null
    tour_id: any | null
    search: string | null
    orderBy: string
    sortBy: string
    upcomingGamesOnly: string | null
    expertRequest: string | null
    playerId: string | null
    ids: Array<any> | null
    tourIds: Array<any> | null
    role: string | null
    activity: string | null
  }
  export interface SessionHistoryRequestData {
    page: number
    itemsPerPage: number
    sortBy: string
    orderBy: string
    playerId: string | null
  }
}
export namespace App.Http.Controllers.Tours {
  export interface CreateTourData {
    title: string
  }
  export interface DeleteTourData {
    id: any
  }
  export interface UpdateTourData {
    id: any
    title: string
  }
}
export namespace App.Http.Controllers.TtsVoice {
  export interface ReplaceTtsVoiceSampleData {
    sample: any
  }
  export interface SelectableTtsVoiceData {
    id: any
    name: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    sampleUrl: string
  }
  export interface SelectableTtsVoicesQueryData {
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    profileId: any | null
    isShared: boolean
  }
  export interface StoreTtsVoiceData {
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    speed: number
    sample: any | null
    organizationId: any | null
  }
  export interface TtsVoiceCatalogItemData {
    id: any
    organizationId: any | null
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    speed: number
    sampleVersion: number
    sampleUrl: string
    profilesCount: number
  }
  export interface TtsVoiceDetachPreviewQueryData {
    organizationId: any | null
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum | null
  }
  export interface UpdateTtsVoiceData {
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    speed: number
    organizationId: any | null
  }
}
export namespace App.Http.Controllers.UserCustomFields {
  export interface StoreUserCustomFieldData {
    title: string
    type: Modules.UserCustomField.Enums.UserCustomFieldTypeEnum
    options: Array<App.Http.Controllers.UserCustomFields.UserCustomFieldOptionInputData>
  }
  export interface UpdateUserCustomFieldData {
    title: string
    options: Array<App.Http.Controllers.UserCustomFields.UserCustomFieldOptionInputData>
  }
  export interface UserCustomFieldOptionInputData {
    title: string
    id: any | null
  }
}
export namespace App.Http.Controllers.Users {
  export interface LoginData {
    id: any
  }
  export interface SwitchActivityData {
    id: any
  }
  export interface UserInfoData {
    id: string | null
    name: string
    last_name: string
    full_name: string | null
    patronymic: string | null
    email: string
    phone: string | null
    timezone: string
    language: string | null
    position_id: string | null
    department_id: string | null
    effectiveness: number
    ranking_place: number
    avatar: boolean
    is_active: boolean
    email_is_verified: boolean
    games_finished: number
    games_time: number
    roles: Array<string>
    organizations: Array<string> | null
    password: string | null
    custom_fields: { [key: string]: string } | null
  }
}
export namespace Modules.AI {
  export interface RecognitionData {
    id: any
    gameId: any
    requestId: string
    transcription: string | null
    recognition: Array<any> | null
    meta: Array<any> | null
  }
  export interface SpeakerMappingReviewData {
    id: any
    status: Modules.Evaluation.Enums.SpeakerMappingStatusEnum
    source: Modules.Evaluation.Enums.SpeakerMappingSourceEnum
    needsReview: boolean
    underReevaluation: boolean
    entries: Array<Modules.AI.SpeakerMappingReviewEntryData>
    speakers: Array<number>
    participantIds: Array<string>
  }
  export interface SpeakerMappingReviewEntryData {
    speaker: number
    playerId: string
    evidence: string
  }
}
export namespace Modules.AI.Enums {
  export enum AIExpertRequestStatusEnum { 'QUEUED' = 'queued', 'IN_PROGRESS' = 'in_progress', 'REQUIRES_ACTION' = 'requires_action', 'CANCELLING' = 'cancelling', 'CANCELLED' = 'cancelled', 'FAILED' = 'failed', 'COMPLETED' = 'completed', 'INCOMPLETE' = 'incomplete', 'EXPIRED' = 'expired' }
  export enum AIPreflightReason { 'ScenarioNotFound' = 'scenario_not_found', 'CompetenceNotFound' = 'competence_not_found', 'CompetenceHasNoSkills' = 'competence_has_no_skills', 'CompetenceHasNoAssistant' = 'competence_has_no_assistant', 'AIAssistantNotFound' = 'ai_assistant_not_found', 'VsaiScenarioHasNoProfile' = 'vsai_scenario_has_no_profile', 'VsaiProfileNotFound' = 'vsai_profile_not_found', 'VsaiProfileHasNoAssistant' = 'vsai_profile_has_no_assistant', 'PromptDefaultMissing' = 'prompt_default_missing', 'PromptHasNoActiveVersion' = 'prompt_has_no_active_version', 'PromptConfigIncomplete' = 'prompt_config_incomplete', 'RubricMissing' = 'rubric_missing', 'RubricHasNoActiveVersion' = 'rubric_has_no_active_version', 'RubricEmpty' = 'rubric_empty' }
  export enum RecognitionStateEnum { 'Missing' = 'missing', 'Pending' = 'pending', 'Stale' = 'stale', 'NoSpeech' = 'no_speech', 'TooLittleSpeech' = 'too_little_speech', 'Ready' = 'ready' }
  export enum SpeakerMappingGuardRuleEnum { 'R1Address' = 'r1_address', 'R2Evidence' = 'r2_evidence', 'Remainder' = 'remainder', 'ForcedByAddress' = 'forced_by_address' }
}
export namespace Modules.AIConnector {
  export interface AIConnectorData {
    id: any
    label: string
    organizationId: any | null
    provider: Modules.AIConnector.Enums.ProviderEnum
    service: Modules.AIConnector.Enums.ServiceEnum
    region: string | null
    endpoint: string | null
    secret: string | null
    secretLast4: string | null
    expiresAt: string | null
    config: Array<any> | null
    maxConcurrency: number | null
    timeoutSec: number | null
    sortOrder: number | null
    status: Modules.AIConnector.Enums.StatusEnum
    disabledAt: string | null
    notes: string | null
    createdAt: string | null
    updatedAt: string | null
  }
}
export namespace Modules.AIConnector.Enums {
  export enum ProviderEnum { 'AZURE' = 'azure', 'AZURE_OPENAI' = 'azure_openai', 'OPENAI' = 'openai', 'ANTHROPIC' = 'anthropic', 'GOOGLE' = 'google', 'AWS' = 'aws', 'ELEVENLABS' = 'elevenlabs', 'YANDEX' = 'yandex', 'DEEPGRAM' = 'deepgram', 'ANAM' = 'anam', 'HUME' = 'hume', 'CARTESIA' = 'cartesia', 'FISHAUDIO' = 'fishaudio' }
  export enum ServiceEnum { 'CHAT' = 'chat', 'REALTIME' = 'realtime', 'EMBEDDINGS' = 'embeddings', 'LLM' = 'llm', 'TTS' = 'tts', 'STT' = 'stt', 'T2I' = 't2i', 'AVATAR' = 'avatar', 'TEXT_LLM' = 'text_llm', 'BATCH_STT' = 'batch_stt' }
  export enum StatusEnum { 'ACTIVE' = 'active', 'DISABLED' = 'disabled', 'ROTATING' = 'rotating' }
}
export namespace Modules.AIProfile {
  export interface AIProfileData {
    id: any
    organizationId: any | null
    aiAssistantId: any | null
    name: string
    settings: Array<any> | null
    avatarUrl: string | null
    aiPromptId: any | null
    loopAvatarId: any | null
    loopAvatar: Modules.LoopAvatar.LoopAvatarSummaryData | null
    realtimeAvatarId: any | null
    realtimeAvatar: Modules.RealtimeAvatar.RealtimeAvatarSummaryData | null
    mascot: Modules.AIProfile.Enums.MascotEnum | null
    activeMascot: Modules.AIProfile.Enums.MascotEnum | null
    ttsVoiceId: any | null
    ttsVoice: Modules.TtsVoice.TtsVoiceSummaryData | null
  }
}
export namespace Modules.AIProfile.Enums {
  export enum MascotEnum { 'Push' = 'push' }
}
export namespace Modules.AIPrompt {
  export interface AIPromptData {
    id: any
    name: string
    content: string
    key: Modules.AIPrompt.Enums.AIPromptKeyEnum | null
    description: string | null
    model: string | null
    temperature: number | null
    topP: number | null
    responseFormat: Array<any> | null
    tools: Array<any> | null
    currentVersionId: any | null
    reasoningEffort: Modules.LLM.Enums.ReasoningEffortEnum | null
  }
  export interface AIPromptVersionData {
    id: any
    aiPromptId: any
    content: string
    createdBy: any | null
  }
}
export namespace Modules.AIPrompt.Enums {
  export enum AIPromptKeyEnum { 'GameEvalNegotiation' = 'game_eval_negotiation', 'GameEvalFeedback' = 'game_eval_feedback', 'GameEvalVsAi' = 'game_eval_vs_ai', 'ProtocolEvaluation' = 'protocol_evaluation', 'VoiceAgent' = 'voice_agent', 'ScenarioGeneration' = 'scenario_generation', 'ScenarioCardUpdate' = 'scenario_card_update', 'ScenarioOptimize' = 'scenario_optimize', 'SkillReportAnalysis' = 'skill_report_analysis', 'SkillReportRecommendations' = 'skill_report_recommendations', 'FactClaimExtraction' = 'fact_claim_extraction', 'GameEvalChecklist' = 'game_eval_checklist', 'MeetingReport' = 'meeting_report', 'MeetingRecap' = 'meeting_recap', 'SpeakerIdentification' = 'speaker_identification' }
  export enum AIPromptNotResolvableReason { 'DefaultMissing' = 'default_missing', 'NoActiveVersion' = 'no_active_version', 'IncompleteConfig' = 'incomplete_config' }
  export enum AIPromptTypeFilter { 'Slot' = 'slot', 'Custom' = 'custom' }
}
export namespace Modules.AiChat.Data {
  export interface ChatMessageData {
    id: any
    role: Modules.AiChat.Enums.ChatRole
    content: string
    citations: Array<{ n: number; document_id: number; document_title: string; chunk_index: number; score: number; content: string }> | null
    status: Modules.AiChat.Enums.ChatMessageStatus
  }
  export interface ChatTurnData {
    assistantMessage: Modules.AiChat.Data.ChatMessageData
    citations: Array<{ n: number; document_id: number; document_title: string; chunk_index: number; score: number; content: string }>
  }
  export interface ConversationData {
    id: any
    scope: Modules.AiChat.Enums.ChatScope
    courseId: any | null
    scenarioId: any | null
    gameId: any | null
    competenceId: any | null
    title: string | null
    preview: string | null
    lastMessageAt: string | null
  }
  export interface ConversationPageData {
    items: Array<Modules.AiChat.Data.ConversationData>
    nextCursor: string | null
  }
  export interface EnqueuedTurnData {
    userMessage: Modules.AiChat.Data.ChatMessageData
    assistantMessage: Modules.AiChat.Data.ChatMessageData
  }
  export interface QuotaData {
    available: boolean
    remaining: number | null
    limit: number | null
  }
  export interface SuggestionData {
    title: string
    subtitle: string
  }
  export interface SuggestionsResponseData {
    status: Modules.AiChat.Enums.ChatSuggestionsStatus
    suggestions: { [key: number]: Modules.AiChat.Data.SuggestionData }
  }
}
export namespace Modules.AiChat.Enums {
  export enum ChatMessageStatus { 'Ready' = 'ready', 'Pending' = 'pending', 'Failed' = 'failed' }
  export enum ChatRole { 'User' = 'user', 'Assistant' = 'assistant', 'System' = 'system' }
  export enum ChatScope { 'KbStudy' = 'kb_study', 'SessionDebrief' = 'session_debrief', 'CompetencyProgress' = 'competency_progress' }
  export enum ChatStage { 'Summarizing' = 'summarizing', 'Searching' = 'searching', 'Reading' = 'reading', 'Writing' = 'writing' }
  export enum ChatSuggestionsStatus { 'Ready' = 'ready', 'Pending' = 'pending' }
  export enum KbSource { 'Course' = 'course', 'Scenario' = 'scenario' }
}
export namespace Modules.Analytics.Data {
  export interface OrgActivityCardData {
    organizationId: string
    organizationName: string
    lastActivityAt: string | null
    lastUserId: string | null
    lastUserName: string | null
    lastEvent: Modules.Analytics.Enums.AdminKeyAuditEvent | null
    playsByDay: { [key: number]: number }
    totalPlays7d: number
  }
  export interface OrgActivityEventData {
    createdAt: string
    userId: string
    userName: string
    event: Modules.Analytics.Enums.AdminKeyAuditEvent
    auditableId: string
  }
}
export namespace Modules.Analytics.Enums {
  export enum AdminKeyAuditEvent { 'GameCreated' = 'game_created', 'VoiceSessionCreated' = 'voice_session_created', 'ScenarioCreated' = 'scenario_created', 'ScenarioUpdated' = 'scenario_updated', 'AIProfileCreated' = 'ai_profile_created', 'ProfileCreated' = 'profile_created' }
}
export namespace Modules.Chat {
  export interface ChatData {
    id: string
    userId: string
    unseenMsgs: number
    messages: Array<any>
  }
  export interface ContactData {
    id: string
    avatar: boolean
    full_name: string
    roles: Array<any> | string
  }
  export interface ContactsAndConversationsData {
    contacts: Array<any>
    chatsContacts: Array<any>
  }
  export interface ConversationData {
    conversation_id: string
    user_id: string
    user_fullname: string
    message_id: string | null
    message: string | null
    message_time: string | null
    sender_id: string | null
    is_seen: boolean | null
  }
  export interface ConversationWithProfileData {
    conversation_id: string
    id: string
    avatar: boolean
    full_name: string
    last_game_number: number | null
  }
  export interface MessageData {
    message: string
    time: string
    senderId: string
    feedback: Modules.Chat.MessageFeedbackData
  }
  export interface MessageFeedbackData {
    isSeen: boolean
    isSent: boolean
    isDelivered: boolean
  }
  export interface NewConversationData {
    organizationId: any
    conversationId: any
    fromUser: any
    toUser: any
  }
  export interface NewMessageData {
    organizationId: any
    messageId: any
    conversationId: any
    fromUser: any
    toUser: any
    text: string
  }
  export interface UserChatData {
    contact: Modules.Chat.ConversationWithProfileData
    chat: Modules.Chat.ChatData
  }
}
export namespace Modules.Chat.DTO {
  export interface MessageNotificationData {
    from: string
    fromId: string | null
    text: string
  }
}
export namespace Modules.Competence {
  export interface AIAssistantData {
    id: any
    externalId: string
    type: Modules.Competence.Enums.AIAssistantTypeEnum
    language: string
    description: string | null
  }
  export interface CompetenceData {
    id: any
    organizationId: any
    AIAssistantId: any | null
    title: string
    text: Array<any> | null
    language: string | null
    departmentId: any | null
    aiPromptId: any | null
    aiPromptKey: Modules.AIPrompt.Enums.AIPromptKeyEnum | null
    evaluationFormat: Modules.Rubric.Enums.EvaluationFormatEnum | null
    rubricId: any | null
  }
  export interface SkillData {
    id: any
    organizationId: any
    competenceId: any
    title: string
    text: Array<any> | null
    plainTextIndicators: string | null
  }
}
export namespace Modules.Competence.Enums {
  export enum AIAssistantTypeEnum { 'NEGOTIATION' = 'negotiation', 'FEEDBACK' = 'feedback', 'AI_PROFILE' = 'ai_profile' }
}
export namespace Modules.Course {
  export interface CourseData {
    id: any
    organizationId: any
    createdBy: any
    title: string
    description: string | null
    documentIds: Array<number>
  }
}
export namespace Modules.Department {
  export interface DepartmentData {
    id: any
    organizationId: any
    title: string
  }
}
export namespace Modules.Evaluation {
  export interface ChecklistCategoryData {
    title: string | null
    items: Array<Modules.Evaluation.ChecklistItemData>
  }
  export interface ChecklistEvaluationData {
    evaluatorType: string
    evaluatorFullname: string
    playerId: string
    playerFullname: string
    passedCount: number
    totalCount: number
    overallComment: string | null
    categories: Array<Modules.Evaluation.ChecklistCategoryData>
  }
  export interface ChecklistItemData {
    criterionId: string
    text: string
    verdict: Modules.Evaluation.Enums.ChecklistVerdictEnum
    evidenceQuote: string
    rationale: string
  }
  export interface CommentData {
    id: any | null
    gameId: any
    authorId: any | null
    playerId: any
    authorType: Modules.Evaluation.Enums.EvaluatorTypeEnum
    text: string
    timestamp: number
  }
  export interface EvaluationData {
    id: any
    gameId: any
    authorId: any | null
    playerId: any
    skillId: any
    authorType: Modules.Evaluation.Enums.EvaluatorTypeEnum
    text: string | null
    score: number
  }
  export interface EvaluationRequestData {
    id: any | null
    gameId: any
    requestedBy: any | null
    evaluatorId: any | null
    status: Modules.Evaluation.Enums.EvaluationRequestStatusEnum | null
    evaluatorType: Modules.Evaluation.Enums.EvaluatorTypeEnum
    speakerMappingId: any | null
    reevaluationInProgress: boolean
  }
  export interface EvaluationsRadarData {
    skillsIds: Array<any> | null
    playerId: any | null
    organizationId: any | null
    startDate: string | null
    endDate: string | null
    evaluatorType: Modules.Evaluation.Enums.EvaluatorTypeEnum | null
    excludeAi: boolean
  }
  export interface PreparedAuthorCommentData {
    id: string
    playerId: string
    playerFullName: string
    timestamp: number
    text: string
  }
  export interface PreparedCommentData {
    authorId: string
    authorFullName: string
    authorType: string
    comments: Array<Modules.Evaluation.PreparedAuthorCommentData>
  }
  export interface PreparedEvaluationData {
    authorId: string
    authorFullname: string
    authorType: string
    evaluationsByPlayer: Array<Modules.Evaluation.PreparedPlayerEvaluationData>
  }
  export interface PreparedPlayerEvaluationData {
    playerId: string
    playerFullname: string
    evaluations: Array<Modules.Evaluation.PreparedPlayerEvaluationsData>
  }
  export interface PreparedPlayerEvaluationsData {
    skillId: string
    score: number
    text: string
  }
}
export namespace Modules.Evaluation.Enums {
  export enum AIEvaluationAbandonReasonEnum { 'RECOVERY_BUDGET_SPENT' = 'recovery_budget_spent', 'RECREATION_BUDGET_SPENT' = 'recreation_budget_spent', 'NO_SPEECH' = 'no_speech', 'TOO_LITTLE_SPEECH' = 'too_little_speech', 'RESPONSE_WEDGED' = 'response_wedged', 'COVERAGE_HELD' = 'coverage_held', 'GAME_EVALUATION_BLOCKED' = 'game_evaluation_blocked' }
  export enum AIRerunRejectionReasonEnum { 'GameAgainstAI' = 'game_against_ai', 'GameEvaluationBlocked' = 'game_evaluation_blocked', 'NoAIEvaluation' = 'no_ai_evaluation', 'EvaluationNotCompleted' = 'evaluation_not_completed', 'AnswerPending' = 'answer_pending', 'RecognitionPending' = 'recognition_pending', 'RecognitionHasNoSpeech' = 'recognition_has_no_speech', 'RecognitionHasTooLittleSpeech' = 'recognition_has_too_little_speech' }
  export enum ChecklistVerdictEnum { 'Pass' = 'pass', 'Fail' = 'fail', 'CannotAssess' = 'cannot_assess' }
  export enum CoverageStatusEnum { 'IN_PROGRESS' = 'in_progress', 'COMPLETE' = 'complete', 'HELD' = 'held' }
  export enum DroppedCommentsRestoreSkipEnum { 'NotPublished' = 'not_published', 'SourceUnknown' = 'source_unknown' }
  export enum EvaluationRequestStatusEnum { 'REQUESTED' = 'requested', 'REJECTED' = 'rejected', 'QUEUED' = 'queued', 'IN_PROGRESS' = 'in_progress', 'CANCELED' = 'canceled', 'COMPLETED' = 'completed' }
  export enum EvaluatorTypeEnum { 'AI' = 'ai', 'EXPERT' = 'expert', 'PLAYER' = 'player', 'MANAGER' = 'manager', 'HEAD' = 'head' }
  export enum ParticipantInterventionKindEnum { 'EvaluationsSwap' = 'evaluations_swap', 'MappingCorrection' = 'mapping_correction', 'MappingConfirmation' = 'mapping_confirmation', 'MappingRecalculation' = 'mapping_recalculation', 'EvaluationRerun' = 'evaluation_rerun' }
  export enum SpeakerMappingEvidenceKindEnum { 'Address' = 'address', 'SelfIntroduction' = 'self_introduction', 'Role' = 'role', 'Other' = 'other', 'Elimination' = 'elimination' }
  export enum SpeakerMappingSourceEnum { 'Model' = 'model', 'Human' = 'human' }
  export enum SpeakerMappingStatusEnum { 'Completed' = 'completed', 'Failed' = 'failed', 'Unavailable' = 'unavailable', 'Empty' = 'empty', 'Skipped' = 'skipped' }
}
export namespace Modules.ExternalLaunch.Enums {
  export enum ConnectionStatusEnum { 'NoCredentials' = 'no_credentials', 'Active' = 'active', 'Expired' = 'expired', 'Disabled' = 'disabled' }
  export enum DeliveryKindEnum { 'Final' = 'final' }
  export enum DeliveryOutcomeEnum { 'Accepted' = 'accepted', 'Confirmed' = 'confirmed', 'RejectedByExternal' = 'rejected_by_external', 'Retry' = 'retry', 'Cancelled' = 'cancelled', 'AssignmentChanged' = 'assignment_changed' }
  export enum DeliveryStatusEnum { 'Pending' = 'pending', 'InProgress' = 'in_progress', 'Done' = 'done', 'NeedsAttention' = 'needs_attention' }
  export enum LaunchEventTypeEnum { 'LaunchRefused' = 'launch_refused', 'ExchangeRefused' = 'exchange_refused', 'ExchangeSucceeded' = 'exchange_succeeded' }
  export enum LaunchRefusalCodeEnum { 'PublicationDisabled' = 'publication_disabled', 'PublicationDraft' = 'publication_draft', 'PublicationExpired' = 'publication_expired', 'FeatureDisabled' = 'feature_disabled', 'ConnectionDisabled' = 'connection_disabled', 'LaunchLimitReached' = 'launch_limit_reached', 'DailyBudgetExhausted' = 'daily_budget_exhausted', 'AttemptsExhausted' = 'attempts_exhausted', 'QuotaExhausted' = 'quota_exhausted', 'UserLimitReached' = 'user_limit_reached', 'ScenarioUnavailable' = 'scenario_unavailable', 'AssignmentCheckUnavailable' = 'assignment_check_unavailable', 'CodeInvalid' = 'code_invalid', 'ChannelVerificationFailed' = 'channel_verification_failed', 'ExternalSystemUnavailable' = 'external_system_unavailable', 'UserNotFound' = 'user_not_found', 'UserUnavailable' = 'user_unavailable', 'UserDeleted' = 'user_deleted', 'EmailTakenLinkingDisabled' = 'email_taken_linking_disabled', 'ServiceRoleNotAllowed' = 'service_role_not_allowed', 'UnverifiedRequest' = 'unverified_request' }
  export enum LaunchResultEnum { 'Passed' = 'passed', 'Failed' = 'failed', 'NotHeld' = 'not_held', 'NoResult' = 'no_result' }
  export enum LaunchStatusEnum { 'Created' = 'created', 'Started' = 'started', 'NotHeld' = 'not_held', 'AwaitingResult' = 'awaiting_result', 'ResultReady' = 'result_ready', 'EvaluationFailed' = 'evaluation_failed', 'ResultTimedOut' = 'result_timed_out', 'AssignmentChanged' = 'assignment_changed', 'Revoked' = 'revoked' }
  export enum LmsEnum { 'Ispring' = 'ispring' }
  export enum PublicationChannelEnum { 'Scorm12' = 'scorm_1_2', 'Scorm2004' = 'scorm_2004' }
  export enum PublicationStatusEnum { 'Draft' = 'draft', 'Active' = 'active', 'Disabled' = 'disabled' }
  export enum RequestProofEnum { 'Unverified' = 'unverified', 'AssignmentVerified' = 'assignment_verified' }
  export enum ResultModeEnum { 'StatusOnly' = 'status_only', 'StatusAndScore' = 'status_and_score', 'StatusScoreAndReview' = 'status_score_and_review' }
}
export namespace Modules.FAQ {
  export interface FAQData {
    id: any
    organizationId: any | null
    title: string
    text: Array<any> | null
    language: string | null
    managersOnly: boolean
  }
}
export namespace Modules.Game {
  export interface GameData {
    id: any
    number: number
    status: Modules.Shared.Enums.GameStatusEnum
    type: Modules.Shared.Enums.GameTypeEnum
    scenarioId: any
    organizationId: any
    expertId: any | null
    createdBy: any
    startedBy: any | null
    startTimeSuggestedBy: any | null
    endedBy: any | null
    tourId: any | null
    startUpTo: string | null
    startTime: string | null
    startedAt: string | null
    endedAt: string | null
    duration: number | null
    preparationTime: number
    protocolTime: number
    participants: Array<Modules.Game.GameParticipantData> | null
    seriesId: any | null
    seriesPosition: number | null
    recordUrl: string | null
    isStartTimeAgreed: boolean | null
    isExpertAgreed: boolean | null
    autoShowResults: boolean
    isCameraRequired: boolean
    isProtocolProposed: boolean | null
    isSelfRated: boolean
    isEachOtherRated: boolean
    isExpertRated: boolean
    isAiRated: boolean
    isTest: boolean
    isPublic: boolean
    isResultsVisible: boolean
    competenceTitle: string
    evaluationFormat: Modules.Rubric.Enums.EvaluationFormatEnum | null
    failureReason: Modules.Shared.Enums.GameFailureReasonEnum | null
    previousGameId: any | null
  }
  export interface GameDescriptionData {
    scenarioTitle: string
    isVsAi: boolean
    description: any
    ownTeam: Modules.Shared.Enums.TeamEnum | null
    sides: Array<Modules.Game.GameDescriptionSideData>
  }
  export interface GameDescriptionSideData {
    team: Modules.Shared.Enums.TeamEnum
    description: any
    playerName: string | null
  }
  export interface GameParticipantData {
    id: any
    gameId: any
    userId: any
    role: Modules.Shared.Enums.GameParticipantRoleEnum
    team: Modules.Shared.Enums.TeamEnum | null
    joinUrl: string | null
    user: any
    preparationNotes: any
    joinedAt: string | null
  }
  export interface GamePreparationData {
    gameId: string | null
    preparationNotes: any
    description: any
    descriptionForTeam: any
  }
  export interface GameSchedulingData {
    id: any
    number: number | null
    startTimeSuggestedBy: any | null
    isStartTimeAgreed: boolean | null
    startTime: string | null
    captains: Array<any> | null
    participants: Array<any> | null
    preparationTime: number | null
  }
  export interface GameStatusSummaryData {
    id: any
    number: number
    status: Modules.Shared.Enums.GameStatusEnum
    endedAt: string | null
    hasEvaluation: boolean
  }
  export interface NewGameData {
    scenarioIds: { [key: number]: string | any }
    organizationId: any | null
    createdBy: any
    expertId: any | null
    tourId: any | null
    observersIds: Array<any> | null
    teamACaptain: any | null
    teamBCaptain: any | null
    startUpTo: string | null
    duration: number | null
    preparationTime: number
    protocolTime: number
    isExpertAgreed: boolean | null
    createMultiScenarioGamesImmediately: boolean | null
    teamAPlayers: Array<any> | null
    teamBPlayers: Array<any> | null
    autoShowResults: boolean
    isCameraRequired: boolean
    isSelfRated: boolean
    isEachOtherRated: boolean
    isExpertRated: boolean
    isAiRated: boolean
    isTest: boolean
    isPublic: boolean
    selectedGameTarget: Modules.Game.Enums.GameTargetEnum | null
    seriesId: any | null
    selectedGameTargetValue: any | null
    selectedGameTargetFieldId: any | null
    seriesPosition: number | null
    startTime: string | null
    type: Modules.Shared.Enums.GameTypeEnum
    copiesPerPlayer: number
    initiatedByPlayer: boolean
  }
  export interface NewGameParticipantData {
    gameId: any
    userId: any
    team: Modules.Shared.Enums.TeamEnum | null
    role: Modules.Shared.Enums.GameParticipantRoleEnum
  }
  export interface PlayerCompetenceGameData {
    gameId: any
    number: number
    scenarioTitle: string
    endedAt: string | null
  }
  export interface PlayerCompetenceGamesData {
    competenceId: any
    competenceTitle: string
    games: Array<Modules.Game.PlayerCompetenceGameData>
  }
  export interface PlayerDashboardData {
    completedGamesCount: number
    totalGamesCount: number
    totalGamesDuration: number
    effectiveness: number
  }
}
export namespace Modules.Game.Enums {
  export enum GameSeriesItemsStatusEnum { 'PENDING' = 'pending', 'CREATED' = 'created', 'COMPLETED' = 'completed' }
  export enum GameTargetEnum { 'USER' = 'user', 'DEPARTMENT' = 'department', 'POSITION' = 'position', 'CUSTOM_FIELD' = 'custom_field' }
}
export namespace Modules.GameResults {
  export interface GameEffectivenessData {
    id: any
    team: Modules.Shared.Enums.TeamEnum
    gameId: any
    details: Modules.GameResults.GameEffectivenessDetailsData
    total: number
  }
  export interface GameEffectivenessDetailsData {
    parameters: Array<Modules.GameResults.GameEffectivenessParameterData>
    questions: Array<Modules.GameResults.GameEffectivenessQuestionData>
    combinationPoints: number
  }
  export interface GameEffectivenessParameterData {
    parameterId: string
    points: number
  }
  export interface GameEffectivenessQuestionData {
    questionId: string
    points: number
  }
}
export namespace Modules.KnowledgeBase.Enums {
  export enum DocumentStatusEnum { 'UPLOADED' = 'uploaded', 'ANALYZING' = 'analyzing', 'EXTRACTING' = 'extracting', 'CHUNKING' = 'chunking', 'EMBEDDING' = 'embedding', 'READY' = 'ready', 'FAILED' = 'failed' }
  export enum DocumentTypeEnum { 'Pdf' = 'pdf', 'Docx' = 'docx', 'Txt' = 'txt', 'Csv' = 'csv', 'Xlsx' = 'xlsx' }
  export enum ScenarioDocumentPurpose { 'EvaluationReference' = 'evaluation_reference', 'VoiceContext' = 'voice_context', 'Both' = 'both' }
}
export namespace Modules.LLM.Enums {
  export enum BackgroundStatus { 'Queued' = 'queued', 'InProgress' = 'in_progress', 'Completed' = 'completed', 'Incomplete' = 'incomplete', 'Failed' = 'failed', 'Cancelled' = 'cancelled', 'Expired' = 'expired' }
  export enum LlmTier { 'Primary' = 'primary', 'Light' = 'light' }
  export enum ReasoningEffortEnum { 'None' = 'none', 'Low' = 'low', 'Medium' = 'medium', 'High' = 'high', 'XHigh' = 'xhigh' }
}
export namespace Modules.Library {
  export interface LibraryData {
    id: any
    organizationId: any
    createdBy: any
    title: string
    isPublic: boolean
    text: Array<any> | null
    cloudUrl: string | null
    previewUrl: string | null
  }
}
export namespace Modules.LoopAvatar {
  export interface LoopAvatarData {
    id: any
    organizationId: any | null
    name: string
    gender: Modules.LoopAvatar.Enums.LoopAvatarGenderEnum
    emotion: Modules.LoopAvatar.Enums.LoopAvatarEmotionEnum
    version: number
  }
  export interface LoopAvatarSummaryData {
    id: any
    name: string
    version: number
    posterUrl: string
  }
}
export namespace Modules.LoopAvatar.Enums {
  export enum LoopAvatarAvailabilityEnum { 'Available' = 'available', 'NotAvailable' = 'not_available', 'OrganizationOnly' = 'organization_only' }
  export enum LoopAvatarEmotionEnum { 'Calm' = 'calm', 'Friendly' = 'friendly', 'Strict' = 'strict' }
  export enum LoopAvatarFileEnum { 'Listen' = 'listen.mp4', 'Talk' = 'talk.mp4', 'Transitions' = 'transitions.json', 'Poster' = 'poster.jpg' }
  export enum LoopAvatarGenderEnum { 'Male' = 'male', 'Female' = 'female' }
}
export namespace Modules.Maintenance {
  export interface MaintenanceSettingsData {
    notificationMessage: string | null
    gamesBlocked: boolean
    updatedAt: string | null
    updatedByName: string | null
  }
}
export namespace Modules.Notification {
  export interface NotificationData {
    id: string
    data: Array<any>
    type: string
    title: string
    time: string
    isSeen: boolean
  }
}
export namespace Modules.Notification.Data {
  export interface EmailStopListCheckData {
    email: string
    platformEntry: Modules.Notification.Data.EmailStopListEntryData | null
    providerConfigured: boolean
    providerAvailable: boolean
    providerListed: boolean | null
    providerReasons: Array<string>
  }
  export interface EmailStopListDomainSuggestionData {
    domain: string
    count: number
  }
  export interface EmailStopListEntryData {
    id: any
    type: Modules.Notification.Enums.EmailStopListEntryTypeEnum
    value: string
    reason: Modules.Notification.Enums.EmailStopListReasonEnum
    providerReply: string | null
    note: string | null
    createdBy: any | null
    createdByName: string | null
    blockedCount: number
    lastBlockedAt: string | null
    createdAt: string
  }
  export interface EmailStopListUnblockData {
    result: Modules.Notification.Enums.EmailStopListUnblockResultEnum
    providerPanelUrl: string | null
  }
}
export namespace Modules.Notification.Enums {
  export enum EmailStopListEntryTypeEnum { 'Address' = 'address', 'Domain' = 'domain' }
  export enum EmailStopListReasonEnum { 'Manual' = 'manual', 'ProviderRejected' = 'provider_rejected' }
  export enum EmailStopListUnblockResultEnum { 'RemovedEverywhere' = 'removed_everywhere', 'StillListedAtProvider' = 'still_listed_at_provider', 'ProviderNotConfigured' = 'provider_not_configured', 'RemovedLocally' = 'removed_locally', 'ProviderUnavailable' = 'provider_unavailable' }
}
export namespace Modules.Organization {
  export interface OrganizationData {
    id: any | null
    name: string
    host: string
    duelLimit: number
    maxUsers: number
    locale: string
    timezone: any
    settings: Modules.Organization.OrganizationSettingsData
    registration: boolean
  }
  export interface OrganizationSettingsData {
    showGameNumbersForPlayer: boolean
    allowPlayersChooseExpert: boolean
    availableLanguages: Array<Modules.Shared.Enums.LanguageEnum>
    svgLogo: string | null
    appTitle: string | null
    browserTitle: string | null
    favicon: string | null
    themeColor: string | null
    themeColorDarken: string | null
    notificationMessage: string | null
    twoFactorAvailable: boolean
    twoFactorMethod: Modules.Shared.Enums.TwoFactorMethodEnum
    hiddenMenuItems: Array<string>
    enabledFeatures: Array<string>
    subscriptionFeatures: Array<string>
    hideAiResults: boolean
    hidePlayerRating: boolean
    showCharacterMemoryToPlayer: boolean
    showMeetingRecapToPlayer: boolean
    createUserOnExternalLaunch: boolean
    allowExternalEmailLinking: boolean
    maxVsAiGamesPerScenario: number | null
    employeeReportDailyLimit: number | null
    employeeReportHourlyLimit: number | null
  }
}
export namespace Modules.Position {
  export interface PositionData {
    id: any
    organizationId: any
    title: string
  }
}
export namespace Modules.Profile {
  export interface ProfileData {
    full_name: string
    id: any
    name: string
    user_id: any
    position_id: any | null
    department_id: any | null
    last_name: string
    effectiveness: number | null
    patronymic: string | null
    phone: any | null
  }
}
export namespace Modules.RealtimeAvatar {
  export interface RealtimeAvatarData {
    id: any
    organizationId: any | null
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    name: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    mediaVersion: number
    availableModels: { [key: number]: string }
    posterUrl: string
    previewUrl: string | null
  }
  export interface RealtimeAvatarSummaryData {
    id: any
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.RealtimeAvatar.Enums.RealtimeAvatarGenderEnum
    posterUrl: string
  }
}
export namespace Modules.RealtimeAvatar.Enums {
  export enum AnamMediaField { 'LandscapeImageUrl' = 'landscapeImageUrl', 'ImageUrl' = 'imageUrl', 'VideoUrl' = 'videoUrl', 'IdleVideoUrl' = 'idleVideoUrl' }
  export enum RealtimeAvatarAvailabilityEnum { 'Available' = 'available', 'NotAvailable' = 'not_available', 'OrganizationOnly' = 'organization_only' }
  export enum RealtimeAvatarFileEnum { 'Poster' = 'poster', 'Preview' = 'preview' }
  export enum RealtimeAvatarGenderEnum { 'Male' = 'male', 'Female' = 'female' }
  export enum RealtimeAvatarPosterFormatEnum { 'Jpg' = 'jpg', 'Png' = 'png', 'Webp' = 'webp' }
}
export namespace Modules.Recruiting.Data {
  export interface CandidateLinkData {
    candidateName: string
    candidateLastName: string
    candidateEmail: string | null
    candidatePhone: string | null
    expiresAt: string | null
    attemptsAllowed: number
    externalNegotiationId: string | null
  }
  export interface CandidateRowData {
    candidate: Modules.Recruiting.Data.CandidateStatusData
    games: { [key: number]: Modules.Game.GameStatusSummaryData }
  }
  export interface CandidateStatusData {
    linkId: any
    candidateName: string
    candidateLastName: string
    candidateEmail: string | null
    candidatePhone: string | null
    status: Modules.Recruiting.Enums.CandidateLinkStatusEnum
    isExpired: boolean
    expiresAt: string
    attemptsAllowed: number
    attemptsUsed: number
    gameIds: { [key: number]: any }
    lastGameId: any | null
    openedAt: string | null
    completedAt: string | null
    consentAcceptedAt: string | null
    consentVersion: string | null
    consentLocale: string | null
    inviteStatus: Modules.Recruiting.Enums.CandidateInviteStatusEnum
    inviteFailureReason: Modules.Recruiting.Enums.CandidateInviteFailureEnum | null
    inviteFailureDetail: string | null
    inviteSentAt: string | null
  }
  export interface IssuedLinkData {
    linkId: any
    token: string
    url: string
    candidateName: string
    candidateLastName: string
    candidateEmail: string | null
    candidatePhone: string | null
    expiresAt: string
    inviteStatus: Modules.Recruiting.Enums.CandidateInviteStatusEnum
    inviteFailureReason: Modules.Recruiting.Enums.CandidateInviteFailureEnum | null
  }
  export interface PublicLinkData {
    organizationName: string
    vacancyTitle: string
    candidateName: string
    durationMinutes: number
    isCameraRequired: boolean
    consentText: string
    consentVersion: string
    locale: string
    status: Modules.Recruiting.Enums.CandidateLinkStatusEnum
    isExpired: boolean
    canStart: boolean
    newSessionScreen: boolean
  }
  export interface VacancyData {
    id: any | null
    organizationId: any
    scenarioId: any
    createdBy: any
    title: string
    status: Modules.Recruiting.Enums.VacancyStatusEnum
    expiresAt: string | null
    externalSource: string | null
    externalId: string | null
  }
}
export namespace Modules.Recruiting.Enums {
  export enum CandidateInviteFailureEnum { 'Rejected' = 'rejected', 'Transport' = 'transport', 'Revoked' = 'revoked', 'SendingDisabled' = 'sending_disabled', 'Blocked' = 'blocked' }
  export enum CandidateInviteStatusEnum { 'NotSent' = 'not_sent', 'Queued' = 'queued', 'Sent' = 'sent', 'Failed' = 'failed' }
  export enum CandidateLinkStatusEnum { 'Created' = 'created', 'Opened' = 'opened', 'InProgress' = 'in_progress', 'Completed' = 'completed', 'Revoked' = 'revoked' }
  export enum VacancyStatusEnum { 'Draft' = 'draft', 'Active' = 'active', 'Archived' = 'archived' }
}
export namespace Modules.Reporting.Enums {
  export enum ClarificationFormEnum { 'Ambiguous' = 'ambiguous', 'NotFound' = 'not_found', 'TooMany' = 'too_many' }
  export enum CompilerStatusEnum { 'NeedInfo' = 'need_info', 'Ready' = 'ready', 'Unsupported' = 'unsupported' }
  export enum DatasetKeyEnum { 'Employees' = 'employees', 'GameParticipations' = 'game_participations', 'SkillEvaluations' = 'skill_evaluations', 'SessionComments' = 'session_comments', 'Vacancies' = 'vacancies', 'Candidates' = 'candidates', 'CandidateEvaluations' = 'candidate_evaluations', 'Scenarios' = 'scenarios', 'Tours' = 'tours', 'ChecklistEvaluations' = 'checklist_evaluations' }
  export enum FieldTypeEnum { 'Text' = 'text', 'Number' = 'number', 'Date' = 'date', 'Boolean' = 'boolean', 'Enum' = 'enum' }
  export enum FilterOperatorEnum { 'Equals' = '=', 'NotEquals' = '!=', 'In' = 'in', 'NotIn' = 'not_in', 'GreaterThan' = '>', 'GreaterThanOrEquals' = '>=', 'LessThan' = '<', 'LessThanOrEquals' = '<=', 'Between' = 'between', 'IsNull' = 'is_null', 'IsNotNull' = 'is_not_null', 'Contains' = 'contains' }
  export enum GranularityEnum { 'Year' = 'year', 'Quarter' = 'quarter', 'Month' = 'month', 'Week' = 'week', 'Day' = 'day', 'DayOfWeek' = 'dow' }
  export enum JoinTypeEnum { 'Inner' = 'inner', 'Left' = 'left' }
  export enum MeasureFunctionEnum { 'Count' = 'count', 'CountDistinct' = 'count_distinct', 'CountFilter' = 'count_filter', 'Ratio' = 'ratio', 'Avg' = 'avg', 'Sum' = 'sum', 'Min' = 'min', 'Max' = 'max', 'Median' = 'median', 'Stddev' = 'stddev' }
  export enum OutputTypeEnum { 'Text' = 'text', 'Number' = 'number', 'Date' = 'date' }
  export enum ReferenceCatalogEnum { 'Department' = 'department', 'Position' = 'position', 'Scenario' = 'scenario', 'Tour' = 'tour', 'Competence' = 'competence', 'Skill' = 'skill', 'Vacancy' = 'vacancy', 'Employee' = 'employee' }
  export enum ReferenceUsageKindEnum { 'Employees' = 'employees', 'Games' = 'games', 'Scenarios' = 'scenarios', 'Evaluations' = 'evaluations', 'Candidates' = 'candidates' }
  export enum RejectionReasonEnum { 'NoSuchMeasure' = 'no_such_measure', 'NoSuchField' = 'no_such_field', 'CrossDataset' = 'cross_dataset', 'WindowFunction' = 'window_function', 'Other' = 'other' }
  export enum ReportStatusEnum { 'Draft' = 'draft', 'Pending' = 'pending', 'Ready' = 'ready', 'Failed' = 'failed' }
  export enum SortDirectionEnum { 'Asc' = 'asc', 'Desc' = 'desc' }
  export enum SpecErrorCodeEnum { 'SpecKeyMissing' = 'spec_key_missing', 'SpecKeyUnknown' = 'spec_key_unknown', 'SpecValueMalformed' = 'spec_value_malformed', 'UnknownDataset' = 'unknown_dataset', 'UnknownField' = 'unknown_field', 'FieldNotSelectable' = 'field_not_selectable', 'FieldNotFilterable' = 'field_not_filterable', 'FieldNotDimension' = 'field_not_dimension', 'UnknownOperator' = 'unknown_operator', 'OperatorNotAllowedForType' = 'operator_not_allowed_for_type', 'FilterValuesArity' = 'filter_values_arity', 'FilterValueMalformed' = 'filter_value_malformed', 'FilterValueNotIdentifier' = 'filter_value_not_identifier', 'TooManyFilterValues' = 'too_many_filter_values', 'TooManyFilters' = 'too_many_filters', 'DuplicateFilterField' = 'duplicate_filter_field', 'DuplicateColumn' = 'duplicate_column', 'DuplicateGroupByField' = 'duplicate_group_by_field', 'UnknownMeasure' = 'unknown_measure', 'DuplicateMeasure' = 'duplicate_measure', 'ModeColumnsWithMeasures' = 'mode_columns_with_measures', 'ModeEmpty' = 'mode_empty', 'GroupByWithoutMeasures' = 'group_by_without_measures', 'HavingWithoutMeasures' = 'having_without_measures', 'SortInGlobalAggregate' = 'sort_in_global_aggregate', 'UnknownGranularity' = 'unknown_granularity', 'GranularityNotAllowed' = 'granularity_not_allowed', 'UnknownSortKey' = 'unknown_sort_key', 'UnknownSortDirection' = 'unknown_sort_direction', 'PeriodFieldNotDate' = 'period_field_not_date', 'PeriodRangeInverted' = 'period_range_inverted', 'InvalidDate' = 'invalid_date', 'HavingUnknownMeasure' = 'having_unknown_measure', 'HavingOperatorNotAllowed' = 'having_operator_not_allowed', 'TooManyColumns' = 'too_many_columns', 'UnknownUnpinField' = 'unknown_unpin_field', 'InvalidLimit' = 'invalid_limit', 'LimitWithoutSort' = 'limit_without_sort', 'LimitInGlobalAggregate' = 'limit_in_global_aggregate' }
  export enum SpecModeEnum { 'Flat' = 'flat', 'GlobalAggregate' = 'global_aggregate', 'GroupedAggregate' = 'grouped_aggregate' }
  export enum TurnOutcomeEnum { 'Spec' = 'spec', 'Clarification' = 'clarification', 'Question' = 'question', 'Rejected' = 'rejected' }
  export enum TurnStatusEnum { 'Pending' = 'pending', 'Ready' = 'ready', 'Failed' = 'failed' }
}
export namespace Modules.Rubric {
  export interface RubricData {
    id: any
    organizationId: any
    name: string
    criteria: Array<any>
    scoringMode: string
    currentVersionId: any | null
  }
  export interface RubricVersionData {
    id: any
    rubricId: any
    content: Array<any>
    createdBy: any | null
  }
}
export namespace Modules.Rubric.Enums {
  export enum EvaluationFormatEnum { 'SkillScores' = 'skill_scores', 'BinaryChecklist' = 'binary_checklist' }
}
export namespace Modules.Scenario {
  export interface ProtocolAnswerOptionData {
    sort: number
    id: string
    text: string
  }
  export interface ProtocolData {
    isProposed: boolean | null
    isApproved: boolean | null
    isDecline: boolean | null
    team: string
    parameters: Array<Modules.Scenario.ProtocolParameterData>
    questions: Array<Modules.Scenario.ProtocolQuestionData>
    questionsTeamB: Array<Modules.Scenario.ProtocolQuestionData> | null
  }
  export interface ProtocolParameterData {
    id: string
    title: string
    target: number
    ratio: number | null
    value: number | null
  }
  export interface ProtocolQuestionData {
    sort: number
    id: string
    text: string
    options: Array<Modules.Scenario.ProtocolAnswerOptionData>
    selectedOption: string | null
  }
  export interface ScenarioAnswerCombinationData {
    id: string | null
    answerIds: Array<any>
    points: number
    team: string | null
  }
  export interface ScenarioData {
    id: string | null
    settings: Modules.Scenario.ScenarioSettingsData
    information: Modules.Scenario.ScenarioInformationData
    parameters: Array<Modules.Scenario.ScenarioParameterData>
    questions: Modules.Scenario.ScenarioQuestionsData
    knowledgeDocuments: Array<Modules.Scenario.ScenarioKnowledgeDocumentData> | null
  }
  export interface ScenarioInformationData {
    has_img: boolean
    title: string
    competence_id: string
    description: any
    description_for_team_a: any
    description_for_team_b: any
    access_level: Modules.Scenario.Enums.ScenarioAccessLevelEnum
    ai_profile_id: string | null
    ai_description: string | null
    ai_description_card: string | null
    next_scenario_id: string | null
    memory_pass_to_next: boolean
    memory_pass_evaluation_to_next: boolean
    memory_evaluate_next_with_agreements: boolean
  }
  export interface ScenarioKnowledgeDocumentData {
    id: number
    purpose: Modules.KnowledgeBase.Enums.ScenarioDocumentPurpose
  }
  export interface ScenarioOptionCombinationData {
    optionIds: Array<any>
    points: number
    team: string | null
  }
  export interface ScenarioParameterData {
    id: string | null
    title: string
    values: Array<Modules.Scenario.ScenarioParameterValueData>
  }
  export interface ScenarioParameterValueData {
    id: string | null
    team: string
    points: number
    ratio: number
  }
  export interface ScenarioQuestionAnswerData {
    sort: number
    id: string | null
    text: string
    points: number
  }
  export interface ScenarioQuestionData {
    sort: number
    id: string | null
    text: string
    team: string
    answers: Array<Modules.Scenario.ScenarioQuestionAnswerData>
  }
  export interface ScenarioQuestionOptionData {
    id: string
    questionId: string
    points: number
  }
  export interface ScenarioQuestionsData {
    questions: Array<Modules.Scenario.ScenarioQuestionData>
    answerCombinations: Array<Modules.Scenario.ScenarioAnswerCombinationData>
  }
  export interface ScenarioQuestionsPointsData {
    options: Array<Modules.Scenario.ScenarioQuestionOptionData>
    combinations: Array<Modules.Scenario.ScenarioOptionCombinationData>
  }
  export interface ScenarioSettingsData {
    min_players: number
    max_players: number
    preparation_time: number
    protocol_time: number
    game_duration: number
    auto_show_results: boolean
    is_team: boolean
    is_camera_required: boolean
    is_self_rated: boolean
    is_each_other_rated: boolean
    is_expert_rated: boolean
    is_ai_rated: boolean
  }
}
export namespace Modules.Scenario.Enums {
  export enum ScenarioAccessLevelEnum { 'PLAYER' = 'player', 'MANAGER' = 'manager', 'ADMIN' = 'admin', 'ALL' = 'all' }
}
export namespace Modules.Shared {
  export interface PaginationData {
    page: number
    itemsPerPage: number
    competence_id: any | null
    status: string | null
    scenario_id: any | null
    tour_id: any | null
    search: string | null
    orderBy: string
    sortBy: string
    upcomingGamesOnly: string | null
    expertRequest: string | null
    playerId: string | null
    ids: Array<any> | null
    tourIds: Array<any> | null
    role: string | null
    activity: string | null
  }
}
export namespace Modules.Shared.Enums {
  export enum ContentDispositionEnum { 'Inline' = 'inline', 'Attachment' = 'attachment' }
  export enum FeatureEnum { 'NOTIFICATIONS_SENDING' = 'notifications-sending', 'NEW_GAMES_VS_AI_PROMPT' = 'new-games-vs-ai-prompt', 'MEETING_MONITOR_RUNE' = 'meeting-monitor-rune', 'SKILL_REPORT' = 'skill-report', 'KNOWLEDGE_BASE' = 'knowledge-base', 'RECRUITING' = 'recruiting', 'AI_REPORTS' = 'ai-reports', 'CHARACTER_MEMORY' = 'character-memory', 'EXTERNAL_LAUNCH' = 'external-launch', 'NEW_SESSION_SCREEN' = 'new-session-screen', 'MEETING_RECAP' = 'meeting-recap', 'STORAGE_DELIVERY_SMOKE' = 'storage-delivery-smoke', 'BBB_MEETINGS' = 'bbb-meetings', 'MASCOT_PUSH' = 'mascot-push' }
  export enum GameFailureReasonEnum { 'ProtocolNotAgreed' = 'protocol_not_agreed', 'ProtocolApprovalExpired' = 'protocol_approval_expired', 'Annulled' = 'annulled', 'Expired' = 'expired', 'AssignmentChanged' = 'assignment_changed' }
  export enum GameParticipantRoleEnum { 'PLAYER' = 'player', 'CAPTAIN' = 'captain', 'OBSERVER' = 'observer', 'MANAGER' = 'manager' }
  export enum GameStatusEnum { 'TIME_SCHEDULING' = 'time_scheduling', 'WAITING_FOR_START' = 'waiting_for_start', 'MISSED' = 'missed', 'IN_PROGRESS' = 'in_progress', 'PROTOCOL_APPROVAL' = 'protocol_approval', 'FAILED' = 'failed', 'COMPLETED' = 'completed' }
  export enum GameTypeEnum { 'PLAYER_VS_PLAYER' = 'player_vs_player', 'PLAYER_VS_AI' = 'player_vs_ai', 'TRAINING' = 'training', 'UPLOADED_RECORDING' = 'uploaded_recording' }
  export enum ImageFormatEnum { 'Jpeg' = 'image/jpeg', 'Png' = 'image/png', 'Gif' = 'image/gif', 'Webp' = 'image/webp' }
  export enum LanguageEnum { 'ENGLISH' = 'en', 'FRENCH' = 'fr', 'RUSSIAN' = 'ru', 'ITALIAN' = 'it', 'GERMAN' = 'de', 'LATVIAN' = 'lv', 'SPANISH' = 'es', 'ESTONIAN' = 'et', 'NEDERLANDS' = 'nl', 'PORTUGUESE_BRAZIL' = 'pt-BR', 'PORTUGUESE_PORTUGUESE' = 'pt-PT', 'KAZAKH' = 'kz', 'POLISH' = 'pl', 'TURKISH' = 'tr' }
  export enum RoleEnum { 'ADMIN' = 'admin', 'SCOPED_ADMIN' = 'scoped_admin', 'PLAYER' = 'player', 'OBSERVER' = 'observer', 'MANAGER' = 'manager', 'EXPERT' = 'expert', 'LEAD_EXPERT' = 'lead_expert', 'HEAD' = 'head', 'SUPPORT' = 'support', 'EARLY_ACCESS' = 'early_access', 'CANDIDATE' = 'candidate' }
  export enum SkillReportStatusEnum { 'Pending' = 'pending', 'CollectingData' = 'collecting_data', 'Analyzing' = 'analyzing', 'GeneratingPdf' = 'generating_pdf', 'Ready' = 'ready', 'Failed' = 'failed' }
  export enum StorageDiskEnum { 'VIDEO' = 'video-records', 'AUDIO' = 'audio-records', 'MEDIA' = 'media', 'SCORM' = 'scorm', 'CLOUD' = 's3', 'CLOUD_MEDIA' = 's3-media', 'CLOUD_SCORM' = 's3-scorm', 'CLOUD_UPLOADS' = 's3-uploads', 'CLOUD_AVATARS' = 's3-avatars', 'CLOUD_REPORTS' = 's3-reports' }
  export enum TeamEnum { 'A' = 'A', 'B' = 'B' }
  export enum TwoFactorMethodEnum { 'Disabled' = 'disabled', 'Email' = 'email', 'Sms' = 'sms' }
}
export namespace Modules.SkillReport.Enums {
  export enum SkillReportArchiveStatusEnum { 'Pending' = 'pending', 'Ready' = 'ready', 'Failed' = 'failed' }
}
export namespace Modules.Subscription.DTO {
  export interface FeatureTicketData {
    id: number
    feature: string
    charges: number
    expiredAt: string | null
    createdAt: string | null
  }
  export interface FeatureUsageData {
    feature: string
    used: number
    limit: number
    remaining: number
  }
  export interface PlanData {
    id: number | null
    name: string
    description: string | null
    periodicityType: string | null
    periodicity: number | null
    graceDays: number
    organizationId: string | null
    features: Array<any>
  }
  export interface SessionUsageData {
    used: number
    limit: number
    remaining: number
  }
  export interface SubscriptionData {
    id: number | null
    planId: number | null
    planName: string | null
    status: string | null
    startedAt: string | null
    expiredAt: string | null
    canceledAt: string | null
    graceDaysEndedAt: string | null
    usage: Array<Modules.Subscription.DTO.FeatureUsageData>
    tickets: Array<Modules.Subscription.DTO.FeatureTicketData>
    sessions: Modules.Subscription.DTO.SessionUsageData | null
  }
}
export namespace Modules.Subscription.Enums {
  export enum SessionUsageRecalculationOutcomeEnum { 'Recalculated' = 'recalculated', 'NoSessionQuota' = 'no_session_quota', 'NoPackageConsumption' = 'no_package_consumption', 'HasSubscription' = 'has_subscription' }
  export enum SubscriptionFeatureEnum { 'RegularGames' = 'regular_games', 'AiGames' = 'ai_games', 'AnyGames' = 'any_games', 'AiChatMessages' = 'ai_chat_messages' }
}
export namespace Modules.Tour {
  export interface TourData {
    id: any
    organizationId: any
    title: string
  }
}
export namespace Modules.TtsVoice {
  export interface TtsVoiceData {
    id: any
    organizationId: any | null
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    speed: number
    sampleVersion: number
    sampleFormat: Modules.TtsVoice.Enums.TtsVoiceSampleFormatEnum
    sampleUrl: string
  }
  export interface TtsVoiceSummaryData {
    id: any
    name: string
    provider: Modules.AIConnector.Enums.ProviderEnum
    externalId: string
    gender: Modules.TtsVoice.Enums.TtsVoiceGenderEnum
    languages: { [key: number]: Modules.Shared.Enums.LanguageEnum }
    speed: number
    sampleVersion: number
    sampleUrl: string
  }
}
export namespace Modules.TtsVoice.Enums {
  export enum TtsVoiceAvailabilityEnum { 'Available' = 'available', 'NotAvailable' = 'not_available', 'OrganizationOnly' = 'organization_only', 'GenderMismatch' = 'gender_mismatch', 'LanguageMismatch' = 'language_mismatch' }
  export enum TtsVoiceGenderEnum { 'Male' = 'male', 'Female' = 'female' }
  export enum TtsVoiceSampleFormatEnum { 'Mp3' = 'mp3', 'Mp4' = 'mp4', 'M4a' = 'm4a' }
}
export namespace Modules.UploadedRecording.Data {
  export interface CreateUploadedRecordingData {
    scenarioId: any
    teamAPlayer: any
    teamBPlayer: any | null
    key: string
  }
  export interface UploadUrlData {
    uploadId: string
    key: string
    url: string
    headers: Array<any>
    expiresAt: string
  }
}
export namespace Modules.User {
  export interface ApiTokenData {
    id: number
    name: string
    abilities: { [key: number]: string }
    last_used_at: string | null
    expires_at: string | null
    created_at: string | null
  }
  export interface AuthData {
    id: any
    email: string
    isEmailVerified: boolean
    isActive: boolean
    language: string | null
    timezone: any | null
    roles: Array<any>
    organizations: Array<any>
  }
  export interface ChangePasswordData {
    current_password: string | null
    new_password: string
    new_password_confirmation: string
  }
  export interface ForgotPasswordData {
    email: string
  }
  export interface ImportSkippedRowData {
    row: number
    email: string
    reason: string
  }
  export interface ImportSummaryData {
    created: number
    updated: number
    skipped: Array<Modules.User.ImportSkippedRowData>
    skippedTruncated: number
  }
  export interface LoginData {
    email: string
    password: string
    remember: boolean
  }
  export interface NewPasswordData {
    token: string
    email: string
    password: string
    password_confirmation: string
  }
  export interface RegistrationData {
    name: string
    last_name: string
    patronymic: string | null
    email: string
    phone: string | null
    password: string
    password_confirmation: string
    timezone: any | null
    privacy_policies: boolean
    email_is_verified: boolean | null
  }
  export interface TwoFactorData {
    code: string
  }
  export interface UpdateTwoFactorSettingData {
    twoFactorMethod: Modules.Shared.Enums.TwoFactorMethodEnum
  }
  export interface UsersRoleCountsData {
    total: number
    counts: { [key: string]: number }
  }
}
export namespace Modules.User.DTO {
  export interface UserOrganizationData {
    id: any
    locale: string | null
    timezone: any | null
  }
  export interface UsersListFilterData {
    page: number
    itemsPerPage: number
    search: string | null
    orderBy: string
    sortBy: string
    role: string | null
    activity: string | null
    activityFrom: string | null
    customFieldId: any | null
    customFieldOptionId: any | null
    lastLogin: Modules.User.Enums.LastLoginFilterEnum | null
    lastLoginFrom: string | null
  }
}
export namespace Modules.User.Enums {
  export enum EmailSourceEnum { 'None' = 'none', 'Asserted' = 'asserted', 'TrustedLms' = 'trusted_lms' }
  export enum ExternalIdentityRefusalEnum { 'UserNotFound' = 'user_not_found', 'UserUnavailable' = 'user_unavailable', 'UserDeleted' = 'user_deleted', 'EmailTakenLinkingDisabled' = 'email_taken_linking_disabled', 'ServiceRoleNotAllowed' = 'service_role_not_allowed', 'UnverifiedRequest' = 'unverified_request' }
  export enum ExternalProviderKindEnum { 'Scorm' = 'scorm' }
  export enum ImportRowMode { 'Create' = 'create', 'Update' = 'update' }
  export enum LastLoginFilterEnum { 'Never' = 'never', 'Since' = 'since' }
  export enum LinkOriginEnum { 'Asserted' = 'asserted', 'AssignmentVerified' = 'assignment_verified', 'EmailLinked' = 'email_linked', 'MovedByAdmin' = 'moved_by_admin' }
  export enum TokenAbilityEnum { 'ExportRead' = 'export:read', 'ExternalLaunchPlay' = 'external-launch:play' }
}
export namespace Modules.UserCustomField {
  export interface UserCustomFieldData {
    id: any | null
    title: string
    type: Modules.UserCustomField.Enums.UserCustomFieldTypeEnum
    sortOrder: number
    options: Array<Modules.UserCustomField.UserCustomFieldOptionData>
  }
  export interface UserCustomFieldOptionData {
    id: any | null
    title: string
    sortOrder: number
  }
}
export namespace Modules.UserCustomField.Enums {
  export enum UserCustomFieldTypeEnum { 'Text' = 'text', 'Select' = 'select' }
}
export namespace Modules.VoiceAgent.Enums {
  export enum ConnectionEventType { 'LkConnecting' = 'lk_connecting', 'LkConnected' = 'lk_connected', 'Ready' = 'ready', 'LkConnectTimeout' = 'lk_connect_timeout', 'LkConnectError' = 'lk_connect_error', 'AgentJoinTimeout' = 'agent_join_timeout', 'ConnectorsUnavailable' = 'connectors_unavailable', 'TokenIssued' = 'token_issued', 'LkRelayFallback' = 'lk_relay_fallback', 'EgressCapacityExhausted' = 'egress_capacity_exhausted' }
  export enum EndSessionReason { 'UserStop' = 'user_stop', 'TimerExpired' = 'timer_expired', 'Navigation' = 'navigation', 'PageClosed' = 'page_closed', 'ConnectionFailed' = 'connection_failed', 'DisconnectFinish' = 'disconnect_finish', 'ExpiredGame' = 'expired_game', 'AccessRevoked' = 'access_revoked', 'AssignmentChanged' = 'assignment_changed' }
  export enum GameMeetingRecapStatus { 'Ready' = 'ready', 'Unavailable' = 'unavailable' }
  export enum GameMeetingReportStatus { 'Ready' = 'ready', 'Unavailable' = 'unavailable' }
  export enum MeetingRecapState { 'Ready' = 'ready', 'Pending' = 'pending', 'Unavailable' = 'unavailable', 'None' = 'none' }
  export enum RecordingLookupStatus { 'Ok' = 'ok', 'NotFound' = 'not_found', 'Error' = 'error' }
  export enum VoiceSessionEnum { 'INACTIVE' = 'inactive', 'LISTENING' = 'listening', 'PROCESSING' = 'processing', 'RESPONDING' = 'responding', 'ENDED' = 'ended' }
  export enum VoiceSessionType { 'OPENAI' = 'openai', 'PIPELINE' = 'pipeline', 'AGENT' = 'agent' }
}
